// src/components/AppNotifications.js
import React, { useState, useEffect, useCallback } from 'react';
import { db } from '../firebase';
import { collection, query, where, orderBy, getDocs } from 'firebase/firestore';
import { FaBell } from 'react-icons/fa';

const AppNotifications = () => {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchActiveNotifications = useCallback(async () => {
        setLoading(true);
        setError(null);

        try {
            const notificationsRef = collection(db, 'appNotifications');

            // Query for only active notifications
            const q = query(
                notificationsRef,
                where('isActive', '==', true),
                orderBy('timestamp', 'desc')
            );

            const querySnapshot = await getDocs(q);

            const fetchedNotifications = querySnapshot.docs.map((doc) => {
                const data = doc.data();
                return {
                    id: doc.id,
                    ...data,
                    timestamp:
                        data.timestamp?.toDate
                            ? data.timestamp.toDate().toLocaleString()
                            : 'No Date',
                };
            });

            // Show only latest 5
            setNotifications(fetchedNotifications.slice(0, 5));
        } catch (err) {
            console.error('Error fetching active app notifications:', err);

            // Firestore missing index error handling
            if (err.message?.includes('index')) {
                setError(
                    '⚠️ Missing Firestore index. Please create it from the Firestore console.'
                );
            } else {
                setError('Failed to load announcements.');
            }
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchActiveNotifications();
    }, [fetchActiveNotifications]);

    // Don’t render anything if still loading or empty
    if (loading) return null;
    if (!loading && notifications.length === 0) return null;

    if (error) {
        return (
            <div className="card notification-card error-card">
                <h3>
                    <FaBell /> Announcements
                </h3>
                <p className="error-message">{error}</p>
            </div>
        );
    }

    return (
        <div className="card notification-card">
            <h3>
                <FaBell /> Announcements
            </h3>
            <ul className="notification-list">
                {notifications.map((n) => (
                    <li
                        key={n.id}
                        className={`notification-item type-${n.type
                            ?.toLowerCase()
                            ?.replace(/\s/g, '-')}`}
                    >
                        <span className="notification-icon">{n.icon || '💬'}</span>
                        <span className="notification-message">
                            <strong>{n.type}:</strong> {n.message}
                        </span>
                        <small className="notification-timestamp">
                            {n.timestamp}
                        </small>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default AppNotifications;
